import React, { Component } from 'react';
import '../../App.css';

// images
import category1 from '../../img/section1.jpg'
import category2 from '../../img/section2.jpg'
import category3 from '../../img/section3.jpg'

class categories extends Component {
  render() {
    return (
      <div className="categories">
        <div id='category'>
            <img src={category1} alt=''/>
            <span>OUR QUALITY</span>
            <p><br/><br/>Our products have quality certifications for both export and consumption.</p>
        </div>
        <div id='category'>
            <img src={category2} alt=''/>
            <span>OUR FARMERS</span>
            <p><br/><br/>Our farmers are people who are passionate about producing fresh, quality food. A tradition that has been passed down from generation to generation.</p>
        </div>
        <div id='category'>
            <img src={category3} alt=''/>
            <span>OUR INNOVATION AND SUSTAINABILITY</span>
            <p>Pioricost has scientific research as one of its main pillars, in order to deliver the highest quality products to our customers with environmental responsibility.</p>
        </div>
      </div>
    );
  }
}

export default categories;


// WEBPACK FOOTER //
// ./src/components/en-home/categories.js